import { render } from "./JumpingJacksGame.vue?vue&type=template&id=d9e34a3e&scoped=true"
import script from "./JumpingJacksGame.vue?vue&type=script&lang=js"
export * from "./JumpingJacksGame.vue?vue&type=script&lang=js"

import "./JumpingJacksGame.vue?vue&type=style&index=0&id=d9e34a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e34a3e"]])

export default __exports__